import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import { categories, type Category } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { platforms } from '@/mocks/platforms';
import { testimonials } from '@/mocks/testimonials';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);
  const recentArticles = articles.slice(0, 6);

  return (
    <>
      <SEOSchema
        type="WebPage"
        title="gay片-精选gay片资源导航与观看指南"
        description="本页专注于gay片内容导航，为成年用户提供gay片分类介绍、观看平台推荐、内容评鉴及安全合规观看建议，帮助用户快速找到高质量gay片资源。"
        url="/"
      />

      <Navbar />

      <main>
        {/* ======= HERO SECTION ======= */}
        <section className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20theater%20interior%20with%20warm%20golden%20spotlight%20illuminating%20empty%20stage%2C%20elegant%20velvet%20curtains%2C%20deep%20rich%20atmosphere%20with%20soft%20ambient%20lighting%2C%20sophisticated%20luxury%20cinema%20aesthetic%2C%20dramatic%20professional%20photography%20with%20moody%20tone&width=1800&height=900&seq=hero-main-2024&orientation=landscape"
              alt="精选gay片资源导航 - 专业观影指南与平台推荐"
              title="精选gay片资源导航与观看指南"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          </div>

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl">
              <p className="text-accent-400 text-sm md:text-base font-medium tracking-wider mb-4 animate-fade-in">
                · 成年用户专属 · 精选gay片资源导航平台
              </p>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                发现高品质
                <span className="text-accent-400"> gay片 </span>
                从这里开始
              </h1>
              <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8 max-w-2xl">
                我们为gay片爱好者提供专业的分类导航、深度评鉴和平台推荐服务。无论你是gay片新手还是资深观众，都能在这里找到值得品味的优质gay片内容。涵盖欧美gay片、亚洲gay片、日本gay片等全品类资源。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/european-american"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-medium rounded-lg hover:bg-accent-400 transition-colors whitespace-nowrap"
                >
                  探索gay片分类
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/30 text-white font-medium rounded-lg hover:bg-white/10 transition-colors whitespace-nowrap"
                >
                  了解我们
                </Link>
              </div>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-white/50 text-xl"></i>
            </div>
          </div>
        </section>

        {/* ======= CATEGORY NAVIGATION ======= */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                gay片分类导航
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                按类型精准浏览，快速找到你感兴趣的gay片内容。每个分类都经过精心整理和评鉴。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {categories.map((cat: Category) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-5 bg-background-100 border border-background-200/70 rounded-lg hover:border-accent-500/30 hover:bg-background-100/80 transition-all duration-300"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4 group-hover:bg-accent-500/20 transition-colors">
                    <i className={`${cat.icon} text-xl text-accent-500`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇gay片文章
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ======= FEATURED ARTICLES ======= */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  精选gay片深度文章
                </h2>
                <p className="text-foreground-500 text-sm">
                  专业gay片评鉴与深度指南，提升你的gay片品鉴水平
                </p>
              </div>
              <Link
                to="/category/european-american"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-accent-500 hover:text-accent-400 font-medium transition-colors whitespace-nowrap"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {featuredArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-500/20 transition-all duration-300"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-accent-500/90 text-background-950 text-xs font-medium rounded-md">
                        {article.categoryName}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ======= RECOMMENDED PLATFORMS ======= */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                gay片在线观看平台推荐
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                经过严格评测筛选的优质gay片平台，安全、稳定、内容丰富的gay片在线观看选择。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {platforms.map((platform) => (
                <div
                  key={platform.name}
                  className="p-6 bg-background-100 border border-background-200/70 rounded-lg hover:border-accent-500/20 transition-all duration-300"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className={`${platform.icon} text-2xl text-accent-500`}></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-base font-semibold text-foreground-900">
                        {platform.name}
                      </h3>
                      <div className="flex items-center gap-1 mt-0.5">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                            <i
                              className={`text-xs ${
                                i < Math.floor(platform.rating)
                                  ? 'ri-star-fill text-accent-500'
                                  : 'ri-star-line text-foreground-300'
                              }`}
                            ></i>
                          </div>
                        ))}
                        <span className="text-xs text-foreground-400 ml-1">{platform.rating}</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3">
                    {platform.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {platform.features.map((f) => (
                      <span
                        key={f}
                        className="px-2.5 py-1 bg-secondary-100 text-secondary-900 text-xs rounded-md"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ======= LATEST ARTICLES ======= */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                最新gay片文章
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                持续更新的gay片知识与资源推荐，保持你的gay片观影清单永远新鲜。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {recentArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group flex gap-4 p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-accent-500/20 transition-all duration-300"
                >
                  <div className="w-24 h-24 rounded-md overflow-hidden flex-shrink-0">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-xs text-accent-500 font-medium">{article.categoryName}</span>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mt-1 mb-2 line-clamp-2 group-hover:text-accent-500 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/category/european-american"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-medium rounded-lg hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                浏览所有gay片文章
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* ======= TESTIMONIALS ======= */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                用户口碑
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                听听gay片爱好者们怎么说，真实用户反馈，值得信赖的gay片导航平台。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              {testimonials.map((t) => (
                <div
                  key={t.name}
                  className="p-5 bg-background-100 border border-background-200/70 rounded-lg"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ======= CTA SECTION ======= */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              即刻开启你的gay片探索之旅
            </h2>
            <p className="text-foreground-500 mb-8 max-w-lg mx-auto">
              海量gay片分类导航、深度评鉴文章、安全平台推荐，一切尽在精选gay片导航。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/european-american"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-medium rounded-lg hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                浏览gay片分类
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}